module.exports = __webpack_public_path__ + "img/pay-box-unknown-error-dark.da4040a1.svg";